module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductAvailabileShippersList":{"heading":"Možnosti dopravy"}},"en":{"ProductAvailabileShippersList":{"heading":"Transport options"}}}')
  delete Component.options._Ctor
}
